<template>
  <div>
    <v-container fluid style="background-color: #E9E9E9">
      <!-- DESKTOP -->
      <v-container class="d-none d-md-flex">
        <v-row>
          <v-col v-if="contactData" cols="3" align-self="center">
            <div
              class="header--contact"
              :style="loggedIn ? 'display: flex; align-items: center;' : ''"
            >
              <contact-modal
                v-if="loggedIn"
                :contact-data="contactData"
                @updated="getContactData()"
              ></contact-modal>
              <div class="tx-1 tx-dark-gray tx-mt-0 tx-b-700">
                Skontaktuj się z nami!
              </div>
            </div>
            <div class="tx-3 tx-b-500 tx-regular-gray mb-5">
              TELNET Systemy Teleinformatyczne Sp. z o. o.
            </div>
            <div class="contact-content" v-html="contactData.content"></div>
          </v-col>

          <v-spacer></v-spacer>

          <v-col md="8" class="d-none d-md-flex">
            <div id="map"></div>
          </v-col>
        </v-row>
      </v-container>

      <!-- TABLET -->
      <v-container class="d-none d-sm-flex d-md-none">
        <v-row v-if="contactData">
          <v-col cols="8">
            <div
              class="header--contact"
              :style="loggedIn ? 'display: flex; align-items: center;' : ''"
            >
              <div class="tx-1 tx-dark-gray tx-mt-0 tx-b-700">
                Skontaktuj się z nami!
              </div>
            </div>
            <div class="tx-3 tx-b-500 tx-regular-gray mb-5">
              TELNET Systemy Teleinformatyczne Sp. z o. o.
            </div>
            <div
              id="contact-content"
              class="contact-content"
              v-html="contactData.content"
            ></div>
          </v-col>
          <v-col cols="4">
            <v-row style="height: 50%;">
              <v-col>
                <v-btn
                  class="v-btn--100proc-height"
                  id="computed-button-height-source-sm"
                  :href="mailtoUrl"
                  block
                  tile
                >
                  <div class="v-btn--100proc-height__label">
                    <font-awesome-icon
                      class="label__icon"
                      :icon="['fas', 'envelope']"
                    ></font-awesome-icon
                    ><span class="label__text">Wyślij email</span>
                  </div></v-btn
                >
              </v-col>
            </v-row>
            <v-row style="height: 50%;">
              <v-col>
                <v-btn
                  class="v-btn--100proc-height"
                  :href="mobileMapAppUrl"
                  block
                  tile
                >
                  <div class="v-btn--100proc-height__label">
                    <font-awesome-icon
                      class="label__icon"
                      :icon="['fas', 'map']"
                    ></font-awesome-icon
                    ><span class="label__text">Nawiguj</span>
                  </div></v-btn
                >
              </v-col>
            </v-row>
          </v-col>
          <v-col cols="12">
            <v-btn
              @click="copyContactContentToClipboard()"
              color="#19a7ab"
              block
              tile
              :height="buttonHeight"
            >
              <div class="v-btn--telnet-colors__label">
                <font-awesome-icon
                  class="label__icon"
                  :icon="['fas', 'copy']"
                ></font-awesome-icon
                ><span class="label__text">Skopiuj dane do schowka</span>
              </div></v-btn
            >
          </v-col>
        </v-row>
      </v-container>

      <!-- PHONE -->
      <v-container class="d-flex d-sm-none">
        <v-row dense v-if="contactData">
          <v-col cols="12">
            <div
              class="header--contact no-bottom-margin"
              :style="loggedIn ? 'display: flex; align-items: center;' : ''"
            >
              <contact-modal
                v-if="loggedIn"
                :contact-data="contactData"
                @updated="getContactData()"
              ></contact-modal>
              <div class="tx-1 tx-dark-gray tx-mt-0 tx-b-700">
                Skontaktuj się z nami!
              </div>
            </div>
          </v-col>

          <v-col cols="4">
            <v-btn
              :height="buttonHeight"
              class="v-btn--100proc-height"
              id="computed-button-height-source-xs"
              :href="mailtoUrl"
              block
              tile
            >
              <div class="v-btn--100proc-height__label">
                <font-awesome-icon
                  class="label__icon"
                  :icon="['fas', 'envelope']"
                ></font-awesome-icon
                ><span class="label__text">Wyślij email</span>
              </div></v-btn
            >
          </v-col>
          <v-col cols="4">
            <v-btn :height="buttonHeight" :href="mobileMapAppUrl" block tile>
              <div class="v-btn--100proc-height__label">
                <font-awesome-icon
                  class="label__icon"
                  :icon="['fas', 'map']"
                ></font-awesome-icon
                ><span class="label__text">Nawiguj</span>
              </div></v-btn
            >
          </v-col>
          <v-col cols="4">
            <v-btn :height="buttonHeight" :href="phoneUrl" block tile>
              <div class="v-btn--100proc-height__label">
                <font-awesome-icon
                  class="label__icon"
                  :icon="['fas', 'phone']"
                ></font-awesome-icon
                ><span class="label__text">Zadzwoń</span>
              </div></v-btn
            >
          </v-col>
          <v-col cols="12">
            <div class="tx-3 tx-b-500 tx-regular-gray mb-5">
              TELNET Systemy Teleinformatyczne Sp. z o. o.
            </div>
          </v-col>
          <v-col cols="12">
            <div
              class="contact-content"
              v-html="contactData ? contactData.content : ''"
            ></div>
          </v-col>
          <v-col cols="12">
            <v-btn
              @click="copyContactContentToClipboard()"
              color="#19a7ab"
              block
              tile
              :height="buttonHeight"
            >
              <div class="v-btn--telnet-colors__label">
                <font-awesome-icon
                  class="label__icon"
                  :icon="['fas', 'copy']"
                ></font-awesome-icon
                ><span class="label__text">Skopiuj dane do schowka</span>
              </div></v-btn
            >
          </v-col>
        </v-row>
      </v-container>
    </v-container>
    <div style="position: absolute; top: -9999px; left: -9999px;">
      <input id="clipboard-input" type="text" aria-label="Schowek"/>
      <div id="transformed-text-container" aria-hidden="true" />
    </div>
  </div>
</template>

<script>
import { Coords } from "@/models/coords.model";
import websiteContents from "@/website-contents";

// Add google map script if it doesn't exist; if exist, return true
window.checkAndAttachGoogleMapsScript = function(callbackOnMapInit) {
  if (window.google) {
    // If you're using vue cli, then directly checking
    // 'google' obj will throw an error at the time of transpiling.
    callbackOnMapInit();
    return true;
  }

  window.callbackOnMapInit = callbackOnMapInit;
  let script = document.createElement("script");
  script.src =
    "https://maps.googleapis.com/maps/api/js?key=AIzaSyBdM5qudVn6w3lWnf1cex6cHZaWTAENmOM&libraries=places,geometry&callback=callbackOnMapInit";
  document.body.appendChild(script);
};

export default {
  name: "contact-component",
  created() {
    window.addEventListener("resize", this.onResize);
  },
  destroyed() {
    window.removeEventListener("resize", this.onResize);
  },
  mounted() {
    this.attachGoogleMaps();
    this.getContactData();
  },
  data: function() {
    return {
      contactData: null,
      buttonHeight: null
    };
  },
  updated() {
    this.onResize();
  },
  methods: {
    onResize: function() {
      setTimeout(() => {
        const xsSourceButton = document.getElementById(
          "computed-button-height-source-xs"
        );
        const smSourceButton = document.getElementById(
          "computed-button-height-source-sm"
        );
        const breakpoint = this.$vuetify.breakpoint;

        if (xsSourceButton && !breakpoint.smAndUp) {
          this.buttonHeight = xsSourceButton.offsetWidth; // no mistype
          // console.log(this.buttonHeight);
        } else if (smSourceButton && !breakpoint.xs && !breakpoint.mdAndUp) {
          this.buttonHeight = smSourceButton.offsetHeight;
        } else {
          this.buttonHeight = 100;
        }
      }, 1000);
    },
    copyContactContentToClipboard() {
      /* Get the text field */
      const clipboardInput = document.getElementById("clipboard-input");

      const contactContent = document.getElementById("contact-content");
      const contactContentCopy = document.createElement("contact-content-copy");

      let innerHTML = contactContent.innerHTML;
      innerHTML = innerHTML.replace(/<br>/gi, " ");
      innerHTML = innerHTML.replace(/<br\/>/gi, " ");
      innerHTML = innerHTML.replace(/<br \/>/gi, " ");
      contactContentCopy.innerHTML = innerHTML;

      clipboardInput.value = contactContentCopy.innerText;

      /* Select the text field */
      clipboardInput.select();
      clipboardInput.setSelectionRange(0, 99999); /*For mobile devices*/

      /* Copy the text inside the text field */
      document.execCommand("copy");

      /* Alert the copied text */
      alert("Skopiowano: " + clipboardInput.value);
    },
    getContactData() {
      this.contactData = websiteContents.footer;
      if (!this.contactData.hq_coords) {
        this.contactData.hq_coords = new Coords();
      }
      this.$emit("loading-finished");
    },
    attachGoogleMaps() {
      window.checkAndAttachGoogleMapsScript(() => {
        const map = new window.google.maps.Map(document.getElementById("map"), {
          center: new Coords(),
          zoom: 18
        });
        new window.google.maps.Marker({
          position: new Coords(),
          map: map
        });

        const interval = setInterval(() => {
          if (this.contactData) {
            const map = new window.google.maps.Map(
              document.getElementById("map"),
              {
                center: {
                  lat: parseFloat(this.contactData.hq_coords.lat),
                  lng: parseFloat(this.contactData.hq_coords.lng)
                },
                zoom: 18
              }
            );
            new window.google.maps.Marker({
              position: {
                lat: parseFloat(this.contactData.hq_coords.lat),
                lng: parseFloat(this.contactData.hq_coords.lng)
              },
              map: map
            });
            clearInterval(interval);
          }
        }, 1000);
      });
    }
  },
  computed: {
    phoneUrl() {
      return `tel://${this.contactData.phone}`; // "tel://1-555-555-5555" (for number like +1 (555) 555-5555)
    },
    loggedIn() {
      return this.$store.state.authentication.loggedIn;
    },
    mobileMapAppUrl() {
      const hqCoords = this.contactData
        ? this.contactData.hq_coords
        : undefined;
      if (hqCoords) {
        const ua = navigator.userAgent.toLowerCase();
        const isAndroid = ua.indexOf("android") > -1;
        if (isAndroid) {
          return `geo:${hqCoords.lat},${hqCoords.lng}`; // geo:50.060915,19.948066
        } else {
          return `http://maps.apple.com/?ll=${hqCoords.lat},${hqCoords.lng}`; // http://maps.apple.com/?ll=50.060915,19.948066
        }
      } else {
        return "#";
      }
    },
    mailtoUrl() {
      return `mailto:${this.contactData.email}`;
    }
  }
};
</script>

<style lang="scss" scoped>
#map {
  height: 728px;
  width: 100%;
  box-shadow: 0 2px 4px -1px rgba(0, 0, 0, 0.2), 0 4px 5px 0 rgba(0, 0, 0, 0.14),
    0 1px 10px 0 rgba(0, 0, 0, 0.12);
}

.header--contact {
  margin-bottom: 21px;
}

.subheader--contact {
  margin-bottom: 19px;
  font-size: 16px;
  color: #707070;
}

.no-bottom-margin {
  margin-bottom: 0;
}

.contact-content {
  font-size: 16px;
  color: #707070;
}

.v-btn--100proc-height {
  height: 100% !important;
}

.v-btn--100proc-height__label,
.v-btn--telnet-colors__label {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.label__icon {
  margin-bottom: 12px;
  font-size: 36px;
  color: #4a4a4a;
}

.label__text {
  text-decoration: initial;
  letter-spacing: initial;
  text-transform: initial;
  font-size: 16px;
  color: #4a4a4a;
}

.v-btn--telnet-colors__label {
  * {
    color: white;
  }
}
</style>
